module.exports = __webpack_public_path__ + "ffe9ba653dc1194b5e5493607f3cb848.svg";